import {isValidNumber} from "../Applications/shared/shared";
import {iaArray, stateArray} from "./programInfo";

module.exports.calcMinPayment = function (balance, interest) {
  if (!isValidNumber(balance)) return null;
  if (!isValidNumber(interest)) return null;
  return Number(balance) * 0.04;
}
module.exports.calcMinPaymentB = function (balance, interest) {
  if (!isValidNumber(balance)) return null;
  if (!isValidNumber(interest)) return null;
  return Number(balance) * 0.025;
}
module.exports.validMinPayment = function (balance, interest, payment) {
  if (!isValidNumber(balance)) return null;
  if (!isValidNumber(interest)) return null;
  if (!isValidNumber(payment)) return null;
  let mRate = (Number(interest) / 100) / 12;
  let minPayment = mRate * Number(balance);
  if (minPayment <= Number(payment)) {
    return true;
  }
  return false;
}
module.exports.ccCalcMonths = function (ccPrin, ccInt, ccPmt, retType) {

  let prin = ccPrin;
  let pmt = 0;
  let prinPort = 0;
  let intPort = 0;
  let count = 0;
  let accruedInt = 0;
  let i = ccInt;

  let Vminpaydol = 15;
  let Vminpayperc = ccPmt / ccPrin;

  while (prin > 0) {
    if (prin * Vminpayperc < Vminpaydol) {
      pmt = Vminpaydol;
    } else {
      pmt = Vminpayperc * prin;
    }
    intPort = i * prin;
    prinPort = pmt - intPort;
    prin = prin - prinPort;
    accruedInt = accruedInt + intPort;
    count++;
    if (count > 600) {
      accruedInt = "0";
      alert("Number of payments exceeds 600.  Please increase the minimum payment percent and recalculate.");
      break;
    } else {
      continue;
    }
  }

  if (retType === 0) {
    return count;
  } else {
    return accruedInt;
  }

};
module.exports.printTime = function (months) {
  if (months <= 0) {
    return "0 Months";
  }
  if (months === 1) {
    return "" + months + " Month";
  } else {
    if (months / 12 >= 1) {
      let years = Math.floor(months / 12);
      let leftMonths = months % 12;
      return "" + years + " yr(s), " + leftMonths + " mo(s)";
    } else {
      return "" + months + " Months";
    }
  }

};

module.exports.calcUp = function (debts) {
  let totalBalance = 0, totalWithInterest = 0, totalMonthly = 0, payoffTime = 0;
  debts.forEach((debt) => {
    debt.balance = Number(debt.balance);
    debt.rate = Number(debt.rate);
    debt.payment = Number(debt.payment);
    totalBalance += debt.balance;
    let mRate = (debt.rate / 100) / 12;
    totalMonthly += debt.payment;
    let minPayment = mRate * Number(debt.balance);
    let months = module.exports.ccCalcMonths(debt.balance, mRate, debt.payment, 0);
    let intPaid = module.exports.ccCalcMonths(debt.balance, mRate, debt.payment, 1);
    //avgInt = avgInt / numMonths;
    totalWithInterest += debt.balance + intPaid;
    if (months > payoffTime) payoffTime = months;
  });
  return {
    balance: (Math.round(totalBalance * 100) / 100).toFixed(2),
    payment: (Math.round(totalMonthly * 100) / 100).toFixed(2),
    winterest: (Math.round(totalWithInterest * 100) / 100).toFixed(2),
    interest: (Math.round((totalWithInterest - totalBalance) * 100) / 100).toFixed(2),
    payoff: payoffTime
  }
}

module.exports.calcConsolidatedProgram = function (debts) {
  let totalBalance = 0, totalWithInterest = 0, totalMonthly = 0, payoffTime = 0, totalCreditors;
  debts.forEach((debt) => {
    debt.balance = Number(debt.balance);
    debt.rate = Number(debt.rate);
    debt.payment = Number(debt.payment);

    totalBalance = +debt.balance;
    let mRate = (debt.rate / 100) / 12;
    totalMonthly += debt.payment;
    let remainingBalance = debt.balance;
    let minPayment = mRate * debt.balance;

    let months = 0;
    let paid = 0;
    let intPaid = 0;

    totalCreditors++;
    while (remainingBalance > 0) {
      months++;
      let balInterest = remainingBalance * (1 + mRate);
      remainingBalance = balInterest - (balInterest < debt.payment ? balInterest : debt.payment);
      paid += parseFloat(balInterest < debt.payment ? balInterest : debt.payment);
    }
    intPaid = paid - debt.balance;
    totalWithInterest += paid;
    if (months > payoffTime) payoffTime = months;
  });
  return {
    balance: (Math.round(totalBalance * 100) / 100).toFixed(2),
    payment: (Math.round(totalMonthly * 100) / 100).toFixed(2),
    winterest: (Math.round(totalWithInterest * 100) / 100).toFixed(2),
    interest: (Math.round((totalWithInterest - totalBalance) * 100) / 100).toFixed(2),
    payoff: payoffTime
  }
}

module.exports.moneyRoundNumber = function (value) {
  return (Math.round(Number(value) * 100) / 100).toFixed(2);
}
module.exports.getState = function (str) {
  return stateArray[str];
}
module.exports.getWord = function (expr, trueWord, falseWord) {
  return expr ? trueWord : falseWord;
}
module.exports.safeObject = function (base, arrayProps = [], defaultVal) {
  if (arrayProps.length === 0) return !!defaultVal || defaultVal === 0 ? defaultVal : null;
  let tObj = base;
  for (let a = 0; a < arrayProps.length; a++) {
    if (!tObj.hasOwnProperty(arrayProps[a])) return !!defaultVal || defaultVal === 0 ? defaultVal : null;
    tObj = tObj[arrayProps[a]];
  }
  return tObj;
}
module.exports.monthDifference = function (oldMonths, newMonths) {
  if (!oldMonths) oldMonths = 0;
  if (!newMonths) newMonths = 0;
  return Math.abs(oldMonths - newMonths);
}
module.exports.calcMonthlyFee = function (state, newPayment, totalCreditors, totalNewBalance, newMonths) {
  if (!state || state === "") return 0;
  state = module.exports.getState(state);
  switch (state.of) {
    case "greater":
      let pay = state.pmt * newPayment;
      let p2 = state.flat;
      if (pay > p2) {
        if (pay > state.top) {
          pay = state.top;
        }
      } else {
        pay = p2;
      }
      return (Math.round(pay * 100) / 100);
    case "lesser":
      p2 = state.pmt * newPayment;
      pay = state.flat;
      if (pay > p2) {
        pay = p2
      }
      return (Math.round(pay * 100) / 100);
    case "flat":
      return state.top;
    case "account":
      let num = totalCreditors;
      if (num > Math.floor(state.top / state.flat)) {
        num = Math.floor(state.top / state.flat);
      }
      return (Math.round(num * state.flat * 100) / 100);
    case "creditor":
      num = totalCreditors;
      if (num > Math.floor(state.top / state.flat)) {
        num = Math.floor(state.top / state.flat);
      }
      return (Math.round(num * state.flat * 100) / 100);
    case "totaldebt":
      return (Math.round(((totalNewBalance * .15 / newMonths) > state.top ? state.top : (totalNewBalance * .15 / newMonths)) * 100) / 100);
    default:
      return 0;
  }
};
module.exports.getCashAmount = function (prodIndex, newMonths) {
  if (!prodIndex || !newMonths) return 0;
  if (prodIndex === "" || prodIndex === "0" || prodIndex === 0) return 0;
  let years = Math.ceil(newMonths / 12);
  if (years < 1) {
    return 0;
  } else if (years > 10) {
    years = 10;
  }
  return Math.round(iaArray[prodIndex].cashAmounts[years] * 100) / 100
};
module.exports.getInsAmount = function (prodIndex, age) {
  if (!prodIndex || !age) return 0;
  if (prodIndex === "" || prodIndex === "0" || prodIndex === 0) return 0;
  if (age === "" || age === "0" || age === 0) return 0;
  return module.exports.safeObject(iaArray, [prodIndex, "insData", age], 0);
};
module.exports.getFSPCost = function (prodIndex, age) {
  if (!prodIndex || !age) return 0;
  if (prodIndex === "" || prodIndex === "0" || prodIndex === 0) return 0;
  if (age === "" || age === "0" || age === 0) return 0;
  return module.exports.safeObject(iaArray, [prodIndex, "cost"], 0);
};


// WEBPACK FOOTER //
// ./src/containers/DebtCalc/calcs.js